<mat-button-toggle-group
  [vertical]="vertical"
  [class.simulated-bootstrap-sm]="size === 'sm'"
  [class.simulated-bootstrap-xs]="size === 'xs'"
  [class.fill-area]="fillArea"
>
  @for (button of buttons; track $index) {
    <mat-button-toggle
      *ngIf="(button.visible$ | async) !== false"
      [value]="value$ | async"
      [class]="contextualClass(button)"
      [disabled]="!!button.disable"
      [checked]="(value$ | async) === button.value"
      [matTooltip]="button.tooltip"
      [matTooltipDisabled]="button.disable"
      (click)="onClick(button)"
    >
      <fa-icon
        *ngIf="button.icon"
        [icon]="button.icon"
        [transform]="button.iconTransform"
        [fixedWidth]="true"
      ></fa-icon>
      <ng-container *ngIf="button.template">
        <ng-container *ngTemplateOutlet="button.template"></ng-container>
      </ng-container>
      {{ button.label }}
    </mat-button-toggle>
  }
  <ng-content></ng-content>
</mat-button-toggle-group>
